import { RadioButton } from '@altify/components';
import clsx from 'clsx';

export interface TabItem<T extends string> {
  value: T;
  label: string;
  selectedLabel?: string;
  className?: string;
  activeClassName?: string;
  iconClassName?: string;
  textClassName?: string;
  icon?: any;
}

export function Tabs<T extends string>({
  items,
  onClickItem,
  activeIndex,
  underline = true,
  small = false,
  size = 'small',
  weight = 'bold',
  className
}: {
  items: TabItem<T>[];
  onClickItem: (item: TabItem<T>) => void;
  activeIndex: number;
  underline?: boolean;
  small?: boolean;
  size?: any;
  weight?: any;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'flex whitespace-nowrap w-full overflow-x-auto no-scrollbar',
        {
          'border-b border-blue-grey pb-2': underline,
        },
      )}>
      {items?.map((item, i) => (
        <RadioButton
          key={i}
          selected={activeIndex === i}
          className={clsx(
            `${small ? 'px-4 mx-1 h-8' : 'px-6 mx-1 h-12'} ${activeIndex === i ? item?.className : ''} `, 
            className, 
            item.activeClassName)}
          textClassName={`${activeIndex === i ? item?.textClassName : ''}`}
          title={item?.label}
          onPress={() => onClickItem(item)}
          size={size}
          weight={weight}
          iconComponent={item?.icon}
          iconClassname={clsx(`${activeIndex === i ? item?.iconClassName : ''}`)}
          iconProps={{ className: item?.iconClassName }}
        />
      ))}
    </div>
  );
}

export default Tabs;
